/**
 * The accent-fill clock: each letter waits for the start delay plus its index
 * times the stagger, then fills over the duration. The duration matches the
 * `accent-fill` animation in `@homeinstead/tailwind-config`.
 */
const ACCENT_TEXT_FILL_START_MILLISECONDS = 500;
const ACCENT_TEXT_FILL_STAGGER_MILLISECONDS = 32;
const ACCENT_TEXT_FILL_DURATION_MILLISECONDS = 300;

export {
  ACCENT_TEXT_FILL_DURATION_MILLISECONDS,
  ACCENT_TEXT_FILL_STAGGER_MILLISECONDS,
  ACCENT_TEXT_FILL_START_MILLISECONDS,
};
